import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';

const Button = ({
  type,
  label,
  disabled,
  loading,
  onClick,
}) => (
  <button
    type={type}
    className={[
      styles.button,
      disabled && styles.disabled,
      loading && styles.loading,
    ].join(' ')}
    disabled={disabled || loading}
    onClick={onClick}
  >
    {!loading && <span className={styles.label}>{label}</span>}
  </button>
);


Button.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  type: 'button',
  disabled: false,
  loading: false,
  onClick: null,
};

export default Button;